"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_CONFIG_UID_JOIN_CHAR = void 0;
exports.documentConfigUid = documentConfigUid;
exports.reKeyDocumentConfigs = reKeyDocumentConfigs;
exports.documentConfigFieldsFromUid = documentConfigFieldsFromUid;
exports.documentConfigWithIds = documentConfigWithIds;
const constants_1 = require("@buildwithflux/constants");
const JOIN_CHAR = "+";
exports.DOCUMENT_CONFIG_UID_JOIN_CHAR = JOIN_CHAR;
/**
 * Takes the required constituent parts of a composite document config uid and produces one, as a string
 */
function documentConfigUid({ key, section, user_uid }) {
    if (key.indexOf(JOIN_CHAR) !== -1 || section.indexOf(JOIN_CHAR) !== -1 || user_uid.indexOf(JOIN_CHAR) !== -1) {
        throw new Error("Invalid component of document config uid");
    }
    return [key, section, user_uid].join(JOIN_CHAR);
}
function reKeyDocumentConfigs(configsList) {
    const configs = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    configsList.forEach((config) => {
        if (!config.uid) {
            // Theoretically, every config has a UID, however we sometimes haven't been setting it: see #2768
            // Until we run a migration to fix that, this forms a matching UID to what we would/should have persisted
            const { key, section, user_uid } = config;
            const uid = documentConfigUid({ key, section, user_uid });
            configs[uid] = { ...config, uid };
        }
        else {
            configs[config.uid] = config;
        }
    });
    return configs;
}
/**
 * Takes a composite document config uid string, and returns the consituent parts if it's well-formed
 *
 * @throws if the documentConfigUid isn't made up of three parts
 */
function documentConfigFieldsFromUid(documentConfigUid) {
    const [key, section, user_uid] = documentConfigUid.split(JOIN_CHAR);
    if (!key || !section || !user_uid) {
        throw new Error(`Invalid documentConfigUid: ${documentConfigUid}`);
    }
    return { key, section, user_uid };
}
function documentConfigWithIds(config, currentUserId) {
    const user_uid = currentUserId || constants_1.ANON_ROLE_UID;
    const { key, section } = config;
    const uid = documentConfigUid({ key, section, user_uid });
    return {
        ...config,
        uid,
        user_uid,
    };
}
//# sourceMappingURL=config.js.map